import { Button } from "@mui/material";
import React from "react";
import StorageIcon from "@mui/icons-material/Storage";
import { useDispatchWrapper } from "../../../hooks";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../../redux/messages/messagesActions";
import { extractHeadersFromFileV2 } from "../../market-campaign/helpers/extractHeadersFromFile";
import { uploadFile } from "../../../components/FileUpload/utils";

interface IExcelFileUplaodButtonAsyncProps {
  onUploadSuccess: (
    path: string,
    extractedHeaders: string[],
    data: Record<string, any>[],
    file?: File
  ) => void;
  moduleName?: string;
}
export const ExcelFileUplaodButtonAsync: React.FC<
  IExcelFileUplaodButtonAsyncProps
> = ({ onUploadSuccess, moduleName = "WHATSAPP_MARKET_CAMPAIGN" }) => {
  const dispatch = useDispatchWrapper();

  const handleFileUploadAsync = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files || event.target.files?.length == 0) return;
    try {
      dispatch(saveLoaderProgress());
      const file = event.target.files[0] as File;

      // Extract headers using frontend parsing
      const headerResult = await extractHeadersFromFileV2(file);

      if (headerResult.success) {
        const path = await uploadFile({
          file: file,
          module_name: moduleName,
          defaultReturn: file.name || "",
          asPayload: {},
          onWarning: (message) => {
            dispatch(
              showMessage({
                type: "warning",
                message: message,
                displayAs: "snackbar",
              })
            );
          },
        });

        onUploadSuccess(path, headerResult.headers, headerResult.data, file);
      } else {
        dispatch(
          showMessage({
            type: "error",
            message:
              headerResult.message || "Failed to extract headers from file",
            displayAs: "snackbar",
          })
        );
      }
    } catch (error) {
      dispatch(
        showMessage({
          type: "error",
          message: "Failed to upload file",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

  return (
    <>
      <Button
        component="label"
        variant="contained"
        color="primary"
        size="large"
        startIcon={<StorageIcon />}
      >
        Import Data From Excel/CSV
        <input
          type="file"
          hidden
          accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
          onChange={handleFileUploadAsync}
        />
      </Button>
    </>
  );
};
